export const yearInterviews: TableModule = {
    name: "yearInterviews",
    route: "spa.basedata.yearInterviews",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "city",
            sortable: true,
            mobile: true
        },
        {
            name: "type",
            sortable: true,
            mobile: true
        },
        {
            name: "date",
            sortable: true,
            mobile: true
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            name: "yearInterviews.create",
            isCreateAction: true,
            ability: [
                "create",
                "yearInterviews"
            ]
        }
    ]
}